module.exports = __webpack_public_path__ + "static/img/bannerNew.bf908a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Virus/Virus/bannerNew.png
// module id = VU7J
// module chunks = 16